
export const openHouse = {
  title: "Jornada de Puertas Abiertas",
  description: "¡Únete a nosotros para descubrir nuestra escuela!",
  subtitle: "¡Esperamos mostrarte por qué Gándara es la elección ideal para el futuro académico de tu hijo!",
  bookVisit: "Reserva tu visita",
  lastSpots: "¡Nuestras puertas están abiertas para ti todos los días!¡Reserva ahora!",
  discover: {
    title: "Descubre Gándara International School",
    description: "con una visita personalizada bajo reserva, a partir de la primera semana de septiembre."
  },
  methodology: {
    title: "En Gándara, creemos en el aprendizaje personalizado",
    description: "adaptado a cada estudiante, y en desarrollar habilidades para un mundo global."
  },
  flexibility: {
    title: "¡Nuestras puertas están abiertas para ti todos los días!",
    description: "Entendemos que los horarios familiares pueden ser complicados, por eso ofrecemos máxima flexibilidad para que nos visites cualquier día."
  }
};
